<template>
  <click-to-edit
    v-model="scope.row.scale.comment_year"
    placeholder=""
    :disabled="!isFieldAvailableForEdit(scope.row, 'scale.comment_year')"
    style="width: 100%"
    type="textarea"
    @input="saveElementPropChange(scope.row, 'scale', {comment_year:$event})"
  ></click-to-edit>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
import {variables} from "@/componentsCompany/smz/variables";
export default {
  name: 'element-comment-year-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {
      scaleTypesEnum: variables.scaleTypesEnum,
    }
  },
  computed: {},
  methods: {

  }
}

</script>

<style scoped lang="scss">
@import "@/assets/css/project-variables";

</style>
